import React, { useState, useEffect } from 'react'
import './navbar.scss'
import { FiMenu, FiX } from 'react-icons/fi'
import MiniNavbar from '../miniNavbar'
import { useSubMenu } from './components/submenu/context/SubMenuContext'
// IMAGENS:
import logoHyaia from '../../assets/navbar/logo-hyaia.png'
import SubMenuProdutos from './components/submenu/subProdutos'
import SubMenuSolutions from './components/submenu/subSolutions'
import SubMenuSuporte from './components/submenu/subSuporte'
import SubMenuExemplo from './components/submenu/subExemplo'
import SubMenuProdutosMob from './components/submenu/subProdutosMob'
import SubMenuSolutionsMob from './components/submenu/subSolutionsMob'
import SubMenuSuporteMob from './components/submenu/subSuporteMob'


import { useTranslation } from 'react-i18next'

const Navbar = () => {
  const [show, setShow] = useState(false)

  const {
    showSubMenuProduct,
    handleShowSubMenuProduct,
    showSubMenuProductMob,
    handleShowSubMenuProductMob,

    showSubMenuSolutions,
    handleShowSubMenuSolutions,
    showSubMenuSolutionsMob,
    handleShowSubMenuSolutionsMob,

    showSubMenuSuporte,
    handleShowSubMenuSuporte,
    showSubMenuSuporteMob,
    handleShowSubMenuSuporteMob,


    showSubMenuExemplo,
    handleShowSubMenuExemplo,
    showSubMenuExemploMob,
    handleShowSubMenuExemploMob,
    closeOnScroll
  } = useSubMenu();


  const { t } = useTranslation()

  useEffect(() => {
    const navbarElem = document.getElementsByClassName("container-navbar-and-sub")
    navbarElem[0].addEventListener('click', closeOnScroll)


  }, [])

  return (
    <>
      <MiniNavbar />
      <div className="container-navbar-and-sub">
        <div className="container-navbar">
          {/* LOGO-NAVBAR */}
          <div className="group-logo-hamburger">
            <div className="logo-navbar">
              <a href="/"> <img src={logoHyaia} alt="logo hyaia" /></a>
            </div>

            {/* hamburger - mobile - navbar */}
            <div className="menu-hamburger">
              {show ? (
                <FiX
                  onClick={() => {
                    setShow(!show)
                  }}
                />
              ) : (
                <FiMenu
                  onClick={() => {
                    setShow(!show)
                  }}
                />
              )}
            </div>
          </div>
          {/* //menu - desktop */}
          <div className="menu">
            <div onClick={handleShowSubMenuProduct}>
              <p>{t("navbar.produtos_menu.title")}</p>
            </div>
            <div onClick={handleShowSubMenuSolutions}>
              <p>{t("navbar.solutions.title")}</p>
            </div>
            <div>
              <a href='/modules'>
                <p>{t("navbar.modules.title")}</p>
              </a>
            </div>
            <div onClick={handleShowSubMenuSuporte}>
              <p>{t("navbar.suport.title")}</p>
            </div>
            <div>
              <a href="/awards">
                <p>{t("navbar.awards.title")}</p>
              </a>
            </div>
            {/* <div onClick={handleShowSubMenuSuporte}>
            <p>SUPORTE</p>
          </div> */}
            <div> {/*VAI JOGAR PRA PAGINA UNICA */}
              <a href="/example">
                <p>{t("navbar.examples.title")}</p>
              </a>
            </div>
            {/*          
          <div>
            <p>PREÇOS</p>
          </div> */}
            <div>
              <a href="/form">
                <button>{t("buttons.demo_btn_alternative_text_2")}</button>
              </a>
            </div>
          </div>
          <div className={show ? 'menu-mobile' : 'menu-mobile-disable'}>
            <div onClick={handleShowSubMenuProductMob}>
              <p>{t("navbar.produtos_menu.title")}
                {
                  showSubMenuProductMob ? (
                    <div className="submenu-navMob">
                      <SubMenuProdutosMob />
                    </div>
                  ) : null
                }
              </p>

            </div>
            <div onClick={handleShowSubMenuSolutionsMob}>
              {t("navbar.solutions.title")}
              {
                showSubMenuSolutionsMob ? (
                  <div className="submenu-navMob">
                    <SubMenuSolutionsMob />
                  </div>
                ) : null
              }
            </div>
            <div>
              <a href="/modules">{t("navbar.modules.title")}</a>
            </div>
            <div onClick={handleShowSubMenuSuporteMob}>
              <p>{t("navbar.suport.title")}</p>
              {
                showSubMenuSuporteMob ? (
                  <div className="submenu-navMob">
                  <SubMenuSuporteMob />
                </div>
                ) : null
              }
            </div>
            <div>
              <a href="/awards">{t("navbar.awards.title")}</a>
            </div>
            <div>
              <a href="/example">{t("navbar.examples.title")}</a>
            </div>
            <div>
              <a href="/form">
                <button>{t("buttons.demo_btn_alternative_text_2")}</button>
              </a>
            </div>
          </div>
        </div>
        {
          showSubMenuProduct ? (
            <div className="submenu-nav">
              <SubMenuProdutos />
            </div>
          ) : null
        }
        {
          showSubMenuSolutions ? (
            <div className="submenu-nav">
              <SubMenuSolutions />
            </div>
          ) : null
        }
        {
          showSubMenuSuporte ? (
            <div className="submenu-nav">
              <SubMenuSuporte />
            </div>
          ) : null
        }
        {
          showSubMenuExemplo ? (
            <div className="submenu-nav">
              <SubMenuExemplo />
            </div>
          ) : null
        }
      </div>
    </>
  )
}
export default Navbar
